export default {
  SMALL_TOKEN_HAS_EXPIRED: 100003, // token小票过期
  BIG_TOKEN_HAS_EXPIRED: 110016, // token大票过期
  TOKEN_IS_EMPTY: 100030, // token为空
  TOKEN_IS_ILLEGAL: 100031, // token非法
  TMP_TOKEN_HAS_EXPIRED: 100034, // 临时token过期
  QY_AGENTID_INVALID: 890012, // agentId非法
}
